import PropTypes from 'prop-types';
import React from 'react';

export const smoothScrollToRef = (ref, style, offset = 0, offsetOverride) => {
  window.scrollTo({
    left: 0,
    top: offsetOverride || (ref?.current?.offsetTop && ref.current.offsetTop - offset) || -offset,
    behavior: style || 'smooth',
  });
};

export const smoothScrollToOffset = (element, offsetAdjust) => {
  if (!element || typeof window === 'undefined') {
    return false;
  }
  const rect = element.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const offset = rect.top + scrollTop;
  window.scrollTo({
    left: 0,
    top: offset - (offsetAdjust || 40),
    behavior: 'smooth',
  });
};

export const scrollToFormTop = (formContainerRef) => {
  const rect = formContainerRef.current.getBoundingClientRect();
  let scrollTop = 0;
  if (typeof window !== 'undefined') {
    scrollTop = window.pageYOffset || window.document.documentElement.scrollTop;
  }
  const refTop = rect.top + scrollTop;
  smoothScrollToRef(formContainerRef, 'smooth', 0, refTop - 32);
};

/**
 * Provides a location to scroll to if needing to be a ref to
 * component
 *
 * @param props
 * @returns {*}
 * @constructor
 */
const ScrollTo = (props) => {
  return <div style={{ height: 0 }} ref={props.reference} {...props} />;
};

ScrollTo.propTypes = {
  /**
   * ref created by React.useRef
   */
  reference: PropTypes.object.isRequired,
};

export default ScrollTo;
